import { getSentry, isSentryEnabled } from "./sentry-state"

export interface MonitorSpanOptions {
  name: string
  op: string
  attributes?: Record<string, string | number | boolean>
  forceTransaction?: boolean
}

export async function withMonitorSpan<T>(
  options: MonitorSpanOptions,
  callback: () => Promise<T> | T
): Promise<T> {
  const sentry = getSentry()

  if (!sentry || !isSentryEnabled()) {
    return callback()
  }

  return sentry.startSpan(
    {
      name: options.name,
      op: options.op,
      attributes: options.attributes,
      forceTransaction: options.forceTransaction,
    },
    async () => callback()
  )
}
